import { clientWfh as client } from './client';
import { WfhConstant } from '../constant';

export const getWfh = async (wfhData) => {
    let body = {
        modulename: WfhConstant.modulename.WfhRoute,
        methodname: WfhConstant.methodname.getWfh,
        payload: wfhData,
    };

    const response = await client(body);

    return { data: response };
};

/**
 * PC_AG_12
 * @param {*} wfhData - has the data to pass as body to request
 * @returns - has list of domain to show filter dropdown
 */
export const getstatus = async (wfhData) => {
    let body = {
        modulename: WfhConstant.modulename.WfhRoute,
        methodname: WfhConstant.methodname.getwfhstatus,
        payload: {},
    };
    const response = await client(body);

    return { data: response };
};

export const getWorkFromHomeById = async (data) => {
    let body = {
        modulename: WfhConstant.modulename.WfhRoute,
        methodname: WfhConstant.methodname.individualwfh,
        payload: data,
    };
    const response = await client(body);

    return { data: response };
};

export const applyWFH = async (data) => {
    let body = {
        modulename: WfhConstant.modulename.WfhRoute,
        methodname: WfhConstant.methodname.postwfhDetails,
        payload: data,
    };
    const response = await client(body);

    return { data: response };
};

export const updateWFH = async (data) => {
    let body = {
        modulename: WfhConstant.modulename.WfhRoute,
        methodname: WfhConstant.methodname.updateWfh,
        payload: data,
    };
    const response = await client(body);

    return { data: response };
};

export const getLeaveById = async (data) => {
    let body = {
        modulename: WfhConstant.modulename.leave,
        methodname: WfhConstant.methodname.reviewRequest,
        payload: data,
    };
    const response = await client(body);
    return { data: response };
};

export const getLeaveTemplate = async (data) => {
    let body = {
        modulename: WfhConstant.modulename.leave,
        methodname: WfhConstant.methodname.leaveTemplate,
        payload: data,
    };
    const response = await client(body);
    return { data: response };
};

export const postLeave = async (data) => {
    let body = {
        modulename: WfhConstant.modulename.leave,
        methodname: WfhConstant.methodname.postLeave,
        payload: data,
    };
    const response = await client(body);
    return { data: response };
};

export const updateLeave = async (data) => {
    let body = {
        modulename: WfhConstant.modulename.leave,
        methodname: WfhConstant.methodname.updateLeave2,
        payload: data,
    };
    const response = await client(body);
    return { data: response };
};

export const leaveCount = async (data) => {
    let body = {
        modulename: WfhConstant.modulename.leave,
        methodname: WfhConstant.methodname.leaveCount2,
        payload: data,
    };
    const response = await client(body);

    return { data: response };
};

export const remainingLeave = async (data) => {
    let body = {
        modulename: WfhConstant.modulename.leave,
        methodname: WfhConstant.methodname.remainingLeave2,
        payload: data,
    };

    const response = await client(body);

    return { data: response };
};

export const getLeave = async (loadGridPostData) => {
    let body = {
        modulename: WfhConstant.modulename.leave,
        methodname: WfhConstant.methodname.getLeave,
        payload: loadGridPostData,
    };
    const response = await client(body);
    return { data: response };
};
export const getLeaveStatus = async () => {
    let body = {
        modulename: WfhConstant.modulename.leave,
        methodname: WfhConstant.methodname.getLeaveStatusDD,
        payload: {},
    };
    const response = await client(body);
    return { data: response };
};
export const getLeaveType = async () => {
    //
    let body = {
        modulename: WfhConstant.modulename.leave,
        methodname: WfhConstant.methodname.getLeaveTypeDD,
        payload: {},
    };
    const response = await client(body);
    return { data: response };
};
export const getDomain = async () => {
    let body = {
        modulename: WfhConstant.modulename.leave,
        methodname: WfhConstant.methodname.getDomainDD,
        payload: {},
    };
    const response = await client(body);
    return { data: response };
};

export const getLeaveInED = async (data) => {
    let body = {
        modulename: WfhConstant.modulename.WfhRoute,
        methodname: WfhConstant.methodname.getLeaveInED,
        payload: data,
    };
    const response = await client(body);
    return { data: response };
};

export const getNotification = async (data) => {
    let body = {
        modulename: WfhConstant.modulename.leave,
        methodname: WfhConstant.methodname.getNotification,
        payload: data,
    };

    const response = await client(body);
    return { data: response };
};

export const updateNotification = async (data) => {
    let body = {
        modulename: WfhConstant.modulename.leave,
        methodname: WfhConstant.methodname.updateNotification,
        payload: data,
    };
    const response = await client(body);
    return { data: response };
};

export const getStateAndRoute = async (data) => {
    let body = {
        modulename: WfhConstant.modulename.leave,
        methodname: WfhConstant.methodname.getStateAndRoute,
        payload: data,
    };
    const response = await client(body);
    return { data: response };
};

export const getWorkdaysCount = async (data) => {
    let body = {
        modulename: WfhConstant.modulename.leave,
        methodname: WfhConstant.methodname.getWorkdaysCount,
        payload: data,
    };
    const response = await client(body);
    return { data: response };
};
